const PublicAssetsEnum = {
  Url: 'https://d1479u97s1i6kv.cloudfront.net/'
}

export default PublicAssetsEnum;